import * as React from 'react'
import videojs, { VideoJsPlayer, VideoJsPlayerOptions } from 'video.js'
import 'video.js/dist/video-js.css'
import { UploadFile } from '../../generated/graphql'
import Portal from '../Portal'

export type VideoPlayerProps = {
  options?: VideoJsPlayerOptions
  video?: UploadFile
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ options: optionProp, video }) => {
  const playerRef = React.createRef<HTMLVideoElement>()

  const player = React.useRef<VideoJsPlayer>()

  const defaultOptions: VideoJsPlayerOptions = {
    autoplay: true,
    controls: true,
    fluid: true,
    sources: [
      {
        src: video?.url || '',
        type: video?.mime || ''
      }
    ],
    ...optionProp
  }

  React.useEffect(() => {
    if (playerRef && playerRef.current) {
      player.current = videojs(playerRef.current, defaultOptions)
    }
    return () => {
      if (player && player.current) {
        player.current.dispose()
      }
    }
  }, [defaultOptions, playerRef])

  return (
    <Portal id="player-node">
      <video data-testid="video-js" ref={playerRef} className="video-js" style={{}} />
    </Portal>
  )
}

export default VideoPlayer
